import React from 'react';
import { LoaderWrapper } from './styles';
import { CircularProgress } from '@mui/material';

type ShowLoadingProps = {
  size?: number;
};

export const ShowLoading = (props?: ShowLoadingProps) => {
  return (
    <LoaderWrapper>
      <CircularProgress {...(props ?? {})} />
    </LoaderWrapper>
  );
};
